import { render } from "./InformeSatisfaccion.vue?vue&type=template&id=31c4a503"
import script from "./InformeSatisfaccion.vue?vue&type=script&lang=js"
export * from "./InformeSatisfaccion.vue?vue&type=script&lang=js"

import "./InformeSatisfaccion.vue?vue&type=style&index=0&id=31c4a503&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__